import React from 'react';

import Money from 'components/Money';

import './styles.css';

const AmountDue = ({amountDue}) => {
  return (
    <div className="AmountDue">
      <div className="section">
        <div className="header">Amount Due</div>
        <div className="value">
          <Money amount={amountDue} />
        </div>
      </div>
    </div>
  );
};

export default AmountDue;
